module.exports = __webpack_public_path__ + "edb26b8dbf848a5cc483eb93091464b2.gif";


//////////////////
// WEBPACK FOOTER
// ./app/assets/preview.gif
// module id = 709
// module chunks = 0